import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

/**
 * SimpleDropdown component.
 *
 * @param {Array} options - Array of option values (can be strings or objects).
 * @param {string} label - Label for the dropdown.
 * @param {any} value - Currently selected value.
 * @param {function} onChange - Callback for selection change (receives event).
 * @param {function} getLabel - Optional function to extract label from option.
 */
const SimpleDropdown = ({ options, label, value, onChange, getLabel }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="generic-dropdown-label">{label}</InputLabel>
      <Select
        labelId="generic-dropdown-label"
        value={value}
        label={label}
        onChange={onChange}
      >
        {options.map((option, idx) => {
          const optionValue = typeof option === 'object' ? option.value ?? option : option;
          const displayLabel = getLabel ? getLabel(option) : String(option);
          return (
            <MenuItem key={idx} value={optionValue}>
              {displayLabel}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SimpleDropdown;
